<template>
  <div>
    <Dialog
      :visible.sync="wonDialog1"
      :style="{ width: '600px', height: '500px', overflowY: 'auto' }"
      header="Won Quotation Details"
      :modal="true"
      class="p-fluid"
      v-cloak
      @drop.prevent="addFile"
      @dragover.prevent
    >
      <div class="p-formgrid p-grid" v-if="isAttachmentPresent()">
        <div class="p-field p-col-12" style="text-align: center;">
          <p>You can also drop the file in this form</p>
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">File Name:</label>
          <div class="p-grid">
            <div class="p-col-12 p-lg-12">
              <div class="p-inputgroup">
                <InputText
                  id="noteHeader"
                  v-model.trim="file.name"
                  required="true"
                  :disabled="true"
                  autofocus
                />
                <Button
                  :disabled="!file.name"
                  class="p-button-danger p-mx-2"
                  icon="pi pi-times"
                  @click="clearFile"
                />
                <Button
                  label="Add file"
                  class="p-button-info"
                  icon="pi pi-plus"
                  @click="clickButton"
                  iconPos="right"
                  :disabled="!isAttachmentPresent()"
                />
                <input
                  single
                  type="file"
                  id="image1"
                  style="display: none;"
                  accept="*/*"
                  @change="onFileSelect"
                  :disabled="!isAttachmentPresent()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="a">{{ label }}</label>
          <InputText id="a" v-model.trim="details" />
          <small class="p-invalid" v-if="submitted && !details"
            >Order Details are required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="a">Manufacturer</label>
          <Dropdown
            v-model="manufacturer"
            :options="activeManufacturers"
            optionLabel="manufacturerName"
            dataKey="id"
            placeholder="Select Manufacturer"
            :showClear="true"
          />
          <small class="p-invalid" v-if="submitted && !manufacturer"
            >Manufacturer is required.</small
          >
        </div>
      </div>

      <template #footer>
        <div class="p-grid" style="padding-top: 10px;">
          <div class="p-lg-3 p-md-3 p-sm-3"></div>
          <div class="p-lg-3 p-md-3 p-sm-3"></div>
          <div class="p-lg-3 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger"
              style="width: 100px;"
              @click="$emit('close')"
            />
          </div>
          <div class="p-lg-3 p-md-3 p-sm-3">
            <ProgressSpinner
              v-if="sendingRequest"
              style="width:25px; height:25px; width: 100px;"
              strokeWidth="5"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
            <Button
              v-else
              label="Save"
              icon="pi pi-check"
              class="p-button-success"
              style="width: 100px;"
              @click="save"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";

export default {
  props: {
    wonDialog: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    reload: {
      type: Number,
      required: false
    },
    sendingRequest: {
      type: Boolean,
      required: true
    }
  },
  created() {
    this.quotationService = new QuotationService();
    this.getAllActiveManufacturersByHard();
  },
  watch: {
    reload(val) {
      this.details = "";
      this.file = {};
      this.submitted = false;
    }
  },
  quotationService: null,
  data: () => ({
    details: "",
    file: {},
    submitted: false,
    manufacturer: null,
    activeManufacturers: []
  }),
  computed: {
    wonDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.wonDialog;
      }
    }
  },
  methods: {
    save() {
      this.submitted = true;
      if (this.details && this.manufacturer) {
        this.$emit("save", {
          file: this.file,
          details: this.details,
          wonManufacturer: this.manufacturer?.id
        });
      }
    },
    async getAllActiveManufacturersByHard() {
      this.activeManufacturers = await this.quotationService.getAllActiveManufacturersByHard();
    },
    isAttachmentPresent() {
      return this.attachment && this.attachment.fileName ? false : true;
    },
    clickButton() {
      document.getElementById("image1").click();
    },
    onFileSelect(e) {
      if (e.target.files && e.target.files[0]) {
        if (e.target.files[0].size < 10485760) {
          this.file = e.target.files[0];
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Big file",
            detail: "File size is greater than 10MB.",
            life: 5000
          });
        }
      }
    },
    clearFile() {
      this.file = {};
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;

      let a = droppedFiles[0];
      //
      a.fileName = a.name;
      this.file = a;
    }
  }
};
</script>

<style></style>
